/* byLivia — page catégorie pendentifs : la photo du visiteur se grave sur CHAQUE pendentif photo de
   la grille, avec le rendu de l'éditeur (perso-photo.js › byliviaPhoto.viewer), sur la photo
   d'ambiance du pendentif (custom.gravure_scene ; à défaut, son gabarit produit).
   Même parcours que la landing :
   - haut de page (collection-perso-hero) : un pendentif de démonstration où la pointe grave
     l'exemple, puis la photo du visiteur (perso-photo.js › reveal) ; un seul bouton « Essayez avec
     votre photo » qui, une fois sa photo gravée, devient « Choisissez votre pendentif » et descend
     à la grille ;
   - grille : sans photo, les vraies photos produit ; avec, seules les simulations sur les
     pendentifs photo (puzzles et colliers texte gardent leur photo produit).
   La photo reste dans le navigateur ; byliviaPhoto.handoff la garde pour la fiche, où elle est déjà
   en place au clic. */
(function () {
  'use strict';

  var CARD_PX = 800; /* côté max de la photo passée aux vignettes : assez pour 700 px, léger à teinter */
  var ERROR_TXT = 'Cette photo ne s\'affiche pas ici : choisissez un pendentif, vous l\'ajouterez sur sa fiche.';

  function all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function zoneOf(el) {
    return (el.getAttribute('data-scene-zone') || '').split(/[\s,;]+/).map(parseFloat).filter(function (n) { return !isNaN(n); });
  }
  function sceneOf(el) {
    var url = el.getAttribute('data-scene'), z = zoneOf(el);
    return url && z.length >= 4 ? { url: url, zone: z, mask: el.getAttribute('data-scene-mask') || null } : null;
  }
  function cfgOf(el) {
    try { return JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { return {}; }
  }
  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { resolve(i); };
      i.onerror = reject;
      i.src = url;
    });
  }
  function toCanvas(src, max) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height;
    var r = Math.min(1, max / Math.max(w, h));
    var s = document.createElement('canvas');
    s.width = Math.round(w * r); s.height = Math.round(h * r);
    var g = s.getContext('2d');
    g.imageSmoothingQuality = 'high';
    g.drawImage(src, 0, 0, s.width, s.height);
    return s;
  }

  /* Collection sans pendentif photo de l'éditeur maison (bracelets cuir) : son bijou photo phare
     (la manchette, photo d'ambiance custom.gravure_scene) est gravé avec notre exemple dès qu'il
     arrive à l'écran, une fois. Pas d'essai de photo ici : toucher le bijou ouvre sa fiche. */
  function bootDemo() {
    var PH = window.byliviaPhoto;
    var stage = document.querySelector('[data-cpp-demo]');
    if (!PH || !stage || stage.hasAttribute('data-ready')) return;
    var cvs = stage.querySelector('[data-cpp-stage-canvas]');
    var sc = sceneOf(stage);
    var url = stage.getAttribute('data-demo-cutout') || stage.getAttribute('data-demo');
    if (!cvs || !sc || !url) return;
    stage.setAttribute('data-ready', '');
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var v = PH.viewer(cvs, { scene: sc, cfg: cfgOf(stage) });
    var started = false;
    function go() {
      if (started) return;
      started = true;
      Promise.all([loadImage(url), v.ready]).then(function (r) {
        var img = toCanvas(r[0], 1400);
        if (reduce || !PH.reveal) v.setPhoto(img); else PH.reveal(cvs, v, img);
      }).catch(function () { /* pas d'exemple : le bijou reste vierge */ });
    }
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { threshold: 0.35 });
    io.observe(stage);
  }

  function boot() {
    bootDemo();
    var PH = window.byliviaPhoto;
    var field = document.querySelector('[data-cpp-try]');
    if (!PH || !field || field.hasAttribute('data-ready')) return;
    var cards = all('[data-cpp-card]');
    if (!cards.length) return;
    field.setAttribute('data-ready', '');

    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var root = field.closest('.cpg') || document.body;
    var grid = document.getElementById('grille') || field;
    var input = field.querySelector('[data-cpp-input]');
    var drop = field.querySelector('[data-cpp-drop]');
    var reset = field.querySelector('[data-cpp-reset]');
    var thumb = field.querySelector('[data-cpp-thumb]');
    var heroSub = document.querySelector('.cph__pcta-sub');
    var heroSubBase = heroSub ? heroSub.textContent : '';
    var work = null, thumbUrl = null;

    /* ---------- Haut de page : le pendentif de démonstration ---------- */
    var stage = document.querySelector('[data-cpp-stage]');
    var stageCvs = stage && stage.querySelector('[data-cpp-stage-canvas]');
    var stageBadge = stage && stage.querySelector('[data-cpp-stage-badge]');
    var badgeBase = stageBadge ? stageBadge.textContent : '';
    var stageV = null, stageFx = null, demo = null;
    if (stage && stageCvs && sceneOf(stage)) {
      stageV = PH.viewer(stageCvs, { scene: sceneOf(stage), cfg: cfgOf(stage) });
      /* Toucher le pendentif = choisir sa photo, tant que ce n'est pas la sienne. */
      stage.addEventListener('click', function () { if (!work) pick(); });
      if (stageBadge) stageBadge.addEventListener('click', function (e) { e.stopPropagation(); pick(); });
    }
    /* Le bouton du haut change quand la photo du visiteur est gravée (classe cpp-photo sur <html>). */
    function markPhoto() { document.documentElement.classList.toggle('cpp-photo', !!work); }
    /* La pointe grave img sur le pendentif du haut ; done() une fois la gravure finie. */
    function stageShow(img, mine, done) {
      if (!stageV) { if (done) done(); return; }
      if (stageFx) { var prev = stageFx; stageFx = null; prev.stop(); }
      if (stageBadge) {
        stageBadge.hidden = false;
        stageBadge.textContent = mine ? stageBadge.getAttribute('data-mine') || 'Votre photo' : badgeBase;
        stageBadge.classList.toggle('is-mine', !!mine);
      }
      if (reduce || !PH.reveal) { stageV.setPhoto(img); if (done) done(); return; }
      stageFx = PH.reveal(stageCvs, stageV, img, function () { stageFx = null; if (done) done(); });
    }
    /* L'exemple : sa version détourée (seul le sujet est gravé, comme à l'atelier). */
    function showDemo() {
      if (!stageV) return;
      if (demo) { stageShow(demo, false); return; }
      var url = stage.getAttribute('data-demo-cutout') || stage.getAttribute('data-demo');
      if (!url) return;
      loadImage(url).then(function (img) {
        demo = toCanvas(img, 1400);
        if (!work) stageShow(demo, false);
      }).catch(function () { /* pas d'exemple : le pendentif reste vierge */ });
    }

    /* ---------- Grille : la photo sur chaque pendentif photo ---------- */
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        render(e.target);
      });
    }, { rootMargin: '400px 0px' }) : null;
    function render(el) {
      if (!work || el._cppWork === work) return;
      if (!el._cpp) {
        el._cpp = PH.viewer(el.querySelector('canvas'), {
          frame: el.getAttribute('data-frame'), plate: el.getAttribute('data-plate'), mask: el.getAttribute('data-mask'),
          scene: sceneOf(el), cfg: cfgOf(el)
        });
      }
      var v = el._cpp, w = work;
      el._cppWork = w;
      v.ready.then(function () {
        if (work !== w) return;
        v.setPhoto(w);
        el.classList.add('is-on');
      }, function () { el._cppWork = null; /* photo indisponible : la carte garde sa photo produit */ });
    }
    function apply() {
      cards.forEach(function (el) {
        if (!work) { el.classList.remove('is-on'); el._cppWork = null; return; }
        if (el._cpp || !io) render(el); else io.observe(el);
      });
      field.hidden = !work;
      root.classList.toggle('has-visitor-photo', !!work);
    }

    function scrollToGrid() { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    function pick() {
      if (!input) return;
      input.value = '';
      input.click();
    }
    function showThumb(file) {
      if (!thumb) return;
      if (thumbUrl) { URL.revokeObjectURL(thumbUrl); thumbUrl = null; }
      if (file) { thumbUrl = URL.createObjectURL(file); thumb.style.backgroundImage = 'url(' + thumbUrl + ')'; }
      else thumb.style.backgroundImage = '';
    }
    function loadFile(file, fromHandoff) {
      if (!file) return;
      PH.readPhoto(file).then(function (c) {
        work = toCanvas(c, CARD_PX);
        showThumb(file);
        if (heroSub) heroSub.textContent = heroSubBase;
        apply();
        if (!fromHandoff) PH.handoff.save(file);
        /* La pointe grave sa photo en haut de page ; le bouton change une fois la gravure finie. */
        stageShow(c, true, markPhoto);
      }).catch(function () {
        /* Format illisible ici (HEIC hors Safari) : le client l'ajoutera sur la fiche. */
        if (!fromHandoff && heroSub) heroSub.textContent = ERROR_TXT;
      });
    }

    if (input) input.addEventListener('change', function () { loadFile(input.files && input.files[0]); });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { loadFile(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    }
    if (reset) reset.addEventListener('click', function () {
      work = null;
      if (input) input.value = '';
      showThumb(null);
      PH.handoff.clear();
      apply();
      markPhoto();
      showDemo();
    });
    /* Bouton du haut de page : sans photo, il ouvre le choix de la photo ; une fois sa photo gravée,
       il descend aux pendentifs. Sans moteur, c'est un simple lien vers la grille. */
    all('[data-cpp-hero]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!document.documentElement.classList.contains('cpp-photo')) { pick(); return; }
        /* Un seul bijou photo dans la collection (la manchette) : droit à sa fiche, photo en place. */
        var go = b.getAttribute('data-cpp-go');
        if (go) window.location.href = go; else scrollToGrid();
      });
    });
    all('[data-cpp-again]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); pick(); });
    });

    /* Le client arrive de la landing ou revient d'une fiche : sa photo est déjà là. Sinon, l'exemple. */
    PH.handoff.take().then(function (f) { if (f && !work) loadFile(f, true); else if (!f) showDemo(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
